// extracted by mini-css-extract-plugin
export default {"validationErrorText":"styles_validationErrorText__zkL4I"};